
/**
 * StyleLinkProcessor - Handles creation of style links for external CSS
 */
export class StyleLinkProcessor {
  /**
   * Creates a secure method to load external CSS that works in cross-origin environments
   * @param cssUrl The URL of the CSS file to load
   * @param id Optional ID for the link element
   */
  static createStyleLink(cssUrl: string, id?: string): HTMLLinkElement {
    console.log(`[DEBUG] StyleLinkProcessor: Creating style link for ${cssUrl} with id ${id || 'none'}`);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    if (id) link.id = id;
    
    // Add attributes to help with cross-origin issues
    link.setAttribute('crossorigin', 'anonymous');
    link.setAttribute('importance', 'high');
    
    // Add error handling
    link.onerror = (e) => {
      console.error(`[ERROR] Failed to load CSS from ${cssUrl}:`, e);
      
      // Create a fallback style element with critical inlined styles
      const fallbackStyle = document.createElement('style');
      fallbackStyle.textContent = `
        /* Emergency fallback styles - minimal set needed */
        .onexip-calculator-container {
          font-family: -apple-system, BlinkMacSystemFont, sans-serif !important; 
          background: white !important;
          padding: 1rem !important;
          border-radius: 0.5rem !important;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
        }
        
        /* Force layout */
        .onexip-calculator-container button {
          padding: 0.5rem 1rem !important;
          background: #FB923C !important;
          color: white !important;
          border: none !important;
          border-radius: 0.25rem !important;
          cursor: pointer !important;
          margin: 0.25rem !important;
        }
      `;
      
      // Add the fallback style to the document/shadow root
      if (link.parentNode) {
        link.parentNode.appendChild(fallbackStyle);
      }
    };

    // Add a load handler to confirm successful loading
    link.onload = () => {
      console.log(`[DEBUG] Successfully loaded CSS from ${cssUrl}`);
    };
    
    console.log(`[DEBUG] Created link element:`, {
      rel: link.rel,
      href: link.href,
      id: link.id || 'none',
      crossorigin: link.getAttribute('crossorigin'),
      importance: link.getAttribute('importance')
    });
    
    return link;
  }
}
